import { AsyncPipe, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LucideAngularModule } from 'lucide-angular';
import { Observable } from 'rxjs';
import { ResponsiveService } from '../../services/reponsive.service';
import { Notification } from '../../models/notification.model';
import { Store } from '@ngrx/store';
import { selectJobsByStatus } from '../../store/jobs/jobs.selects';
import { Job } from '../../class/job.class';
import { JobRowComponent } from '../../components/job-row/job-row.component';
import { Task } from '../../class/task.class';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifications',
  imports: [NgClass, LucideAngularModule, AsyncPipe, TranslateModule, JobRowComponent],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss'
})
export class NotificationsComponent {

  constructor(

  ) { }

  private responsiveService: ResponsiveService = inject(ResponsiveService);
  private store: Store = inject(Store);
  private router: Router = inject(Router);

  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  notifications$: Observable<Notification[]> = new Observable<Notification[]>();

  jobs$: Observable<Job[]> = this.store.select(selectJobsByStatus('WAITING_RESPONSE'))

  navToAction(job: Job): void {
    const actions: Task[] = job.tasks.filter(task => task.status === 'WAITING_RESPONSE');
    if (actions.length > 0) {
      const task: Task = actions[0];
      switch (task.type) {
        case 'VIDEO_EDITING':
          this.router.navigate(['dashboard','job', job.id, task.id, 'video-editing']);
          break;
        default:
          console.warn(`No action defined for task type: ${task.type}`);
          break;
      }
    } else {
      console.warn('No action available for this job');
    }
  }

}
